<section>
  <div class="logo"></div>
  <div class="form-container">
    <form [formGroup]="entity">
      <div class="col-12">
        <div class="main-title">
          Iniciar sesión
        </div>
      </div>
      <div class="grid">
        <div class="col-12">
          <p-messages [(value)]="responseMessage" [enableService]="showMessage" [closable]="true" [escape]="false"></p-messages>
        </div>
        <div class="col-12">
          <div class="field field-flex">
            <label for="identifier">
              <span class="p-error">*</span>Email:
            </label>
            <input type="text" pInputText id="identifier" formControlName="identifier" placeholder="Teléfono o email" required />
            <ng-container *ngIf="entity.get('identifier')?.invalid && (entity.get('identifier')?.dirty || entity.get('identifier')?.touched)">
              <small class="p-error" *ngIf="entity.get('identifier')?.errors?.['required']">El campo es obligatorio.</small>
              <small class="p-error" *ngIf="entity.get('identifier')?.errors?.['email']">Debe ingresar un email válido.</small>
            </ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="field field-flex">
            <label for="password">
              <span class="p-error">*</span>Contraseña:
            </label>
            <p-password [feedback]="false" placeholder="************" formControlName="password" [toggleMask]="true"></p-password>
            <ng-container *ngIf="entity.get('password')?.invalid && (entity.get('password')?.dirty || entity.get('password')?.touched)">
              <small class="p-error" *ngIf="entity.get('password')?.errors?.['required']">El campo es obligatorio.</small>
            </ng-container>
          </div>
        </div>

        <div class="col-12 flex flex-column align-items-center gap-2">
          <button pButton pRipple type="submit" label="Iniciar sesión" icon="fa-solid fa-lock" class="p-button-success" (click)="login()" [disabled]="entity.invalid"></button>
          <div class="text-sm text-color-secondary flex align-items-center justify-content-center flex-wrap gap-1">
            <span>¿No puedes iniciar sesión?</span>
            <button pButton pRipple type="button" label="click aquí" class="p-button-link p-button-sm p-0" (click)="forgotPassword()"></button>
            <span>para reiniciar tu contraseña</span>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
